var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "#2B55EF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.6655V16.9984H3.33288L13.1627 7.16864L9.82978 3.83576L0 13.6655ZM15.7401 4.59121C15.8225 4.50899 15.8878 4.41132 15.9324 4.3038C15.977 4.19629 16 4.08103 16 3.96463C16 3.84823 15.977 3.73297 15.9324 3.62545C15.8878 3.51793 15.8225 3.42027 15.7401 3.33805L13.6604 1.25833C13.5781 1.17594 13.4805 1.11057 13.373 1.06597C13.2654 1.02137 13.1502 0.998413 13.0338 0.998413C12.9174 0.998413 12.8021 1.02137 12.6946 1.06597C12.5871 1.11057 12.4894 1.17594 12.4072 1.25833L10.7808 2.88477L14.1136 6.21766L15.7401 4.59121Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.20500eea01af592668c00b8c081d1ea0.svg";
export { ForwardRef as ReactComponent };